module.exports = __webpack_public_path__ + "img/amazon_icon.ee5e437b.png";